import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Seller, SellerActionTypes, SellerFailure, SellerSuccess } from '../actions/sellerActions';
import { SellerService } from '../../app/pages/seller/seller.service';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';

@Injectable()
export class SellerEffects {

  constructor(
    private actions: Actions,
    private sellerService: SellerService
  ) { }


  @Effect()
  Seller: Observable<any> = this.actions
    .ofType(SellerActionTypes.SELLER)
    .map((action: Seller) => action)
    .switchMap(payload => {
      return this.sellerService.seller().map((data) => {
        return new SellerSuccess({ seller: data.data });
      })
        .catch((error) => {
          return Observable.of(new SellerFailure({ error: error }));
        });
    });

  @Effect({ dispatch: false })
  SellerSuccess: Observable<any> = this.actions.pipe(
    ofType(SellerActionTypes.SELLER_SUCCESS)
  );

  @Effect({ dispatch: false })
  SellerFailure: Observable<any> = this.actions.pipe(
    ofType(SellerActionTypes.SELLER_FAILURE)
  );
}
